/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from 'react';
import moment from 'moment';
import {useIntl} from 'react-intl';
import {toAbsoluteUrl} from '../../../_metronic/helpers';
import {PageTitle} from '../../../_metronic/layout/core';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {requestPOST, requestGET, requestPOST_NEW, requestPUT_NEW} from 'src/utils/baseAPI';
import {useAuth} from 'src/app/modules/auth';
import {DatePicker, Space} from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import locale from 'antd/es/date-picker/locale/vi_VN';
import _ from 'lodash';
import {CheckRole} from 'src/utils/utils';

const {RangePicker} = DatePicker;

const DashboardPage = () => {
  const {currentUser, logout} = useAuth();
  const currentPermissions = currentUser?.permissions;

  const dateFormat = 'DD/MM/YYYY';

  const [fromDateToDate, setFromDateToDate] = useState({
    fromDate: dayjs().startOf('month'),
    toDate: dayjs().endOf('month'),
  });

  const [tongHopThietBi, setTongHopThietBi] = useState(null);

  const [optionChart, setOption] = useState({
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [],
      labels: {
        useHTML: true, //Set to true
        autoRotationLimit: 30,
      },
    },
    yAxis: [
      {
        min: 0,
        title: {
          text: '',
        },
      },
      {
        title: {
          text: '',
        },
        opposite: false,
      },
    ],
    legend: {
      shadow: false,
      enabled: false,
      itemWidth: 50,
    },
    tooltip: {
      shared: true,
    },
    plotOptions: {
      column: {
        grouping: true,
        shadow: false,
        borderWidth: 0,
        pointPadding: 0.3,
      },
    },
    credits: {
      enabled: false,
    },
    colors: ['#4198d7'],
    series: [
      {
        name: 'Doanh thu',
        data: [],
      },
    ],
  });
  const [optionColumn, setOptionColumn] = useState(null);
  const [optionLine, setOptionLine] = useState(null);
  const [optionChartChiNhanhThietBi, setOptionChartChiNhanhThietBi] = useState({
    credits: {
      enabled: false,
    },
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },

    xAxis: {
      categories: [],
    },

    yAxis: [
      {
        // Primary axis
        className: 'highcharts-color-0',
        title: {
          text: 'Doanh thu',
        },
      },
      {
        // Secondary axis
        className: 'highcharts-color-1',
        opposite: true,
        title: {
          text: 'Thiết bị',
        },
      },
    ],

    plotOptions: {
      column: {
        borderRadius: 5,
      },
    },

    series: [
      {
        name: 'Doanh thu',
        data: [],
        tooltip: {
          valueSuffix: ' VND',
        },
      },
      {
        name: 'Thiết bị',
        data: [],
        yAxis: 1,
      },
    ],
  });

  useEffect(() => {
    const fetchData = async () => {
      const res = await requestPOST_NEW(`api/v1/dashboard/tonghopthietbi`, {
        branchId: currentUser?.branchId ?? null,
      });

      var _data = res?.data?.data ?? null;
      if (_data) {
        setTongHopThietBi(_data);
      }
    };
    fetchData();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (date, dateString) => {
    setFromDateToDate({
      fromDate: date[0],
      toDate: date[1],
    });
  };
  const getOptionColumn = (_data) => {
    const groupedData = _(_data)
      .groupBy('code')
      .map((items, code) => ({
        code: code,
        name: items[0].name,
        total: _.sumBy(items, (i) => i.totalAmount),
      }))
      .value();
    let arr_ChiNhanh = [];
    let arr_DoanhThu = [];
    groupedData?.map((i) => {
      arr_ChiNhanh.push(i?.name);
      arr_DoanhThu.push(i?.total ?? 0);
    });
    setOptionColumn({
      chart: {
        type: 'column',
      },
      title: {
        text: 'Biểu đồ doanh thu theo đơn vị',
      },
      xAxis: {
        categories: arr_ChiNhanh,
      },
      yAxis: {
        title: null,
      },
      legend: {
        shadow: false,
        enabled: false,
        itemWidth: 50,
      },
      tooltip: {
        shared: true,
      },
      plotOptions: {
        column: {
          grouping: true,
          shadow: false,
          borderWidth: 0,
          pointPadding: 0.3,
        },
      },
      credits: {
        enabled: false,
      },
      colors: ['#4198d7'],

      series: [
        {
          name: 'Doanh thu',
          tooltip: {
            valueSuffix: ' VND',
          },
          data: arr_DoanhThu,
        },
      ],
    });
  };
  const getOptionLine = (_data) => {
    const groupedData = _(_data)
      .groupBy('payDate')
      .map((items, payDate) => ({
        date: payDate,
        // list: items,
        totalVNPay: _.sumBy(items, (i) => i?.amountVNPay ?? 0),
        totalCash: _.sumBy(items, (i) => i?.amountCash ?? 0),
      }))
      .value();
    let count = fromDateToDate.toDate.diff(fromDateToDate.fromDate, 'day');
    let dataAll = [];
    let arr_VNPay = [];
    let arr_Cash = [];
    for (let i = 0; i <= count; i++) {
      let time = fromDateToDate.fromDate.add(i, 'day').format('YYYY-MM-DD');
      let item = groupedData?.find((item) => item.date == time);
      let text = Date.UTC(moment(time).get('year'), moment(time).get('month'), moment(time).get('date'));
      arr_VNPay.push([text, item?.totalVNPay ?? 0]);
      arr_Cash.push([text, item?.totalCash ?? 0]);
    }

    // groupedData?.map((i) => {
    //   if (i?.list?.length > 0) {
    //     arr_VNPay.push(_.sumBy(i?.list, (i) => i.amountVNPay));
    //     arr_Cash.push(_.sumBy(i?.list, (i) => i.amountCash));
    //   }
    // });
    setOptionLine({
      chart: {
        type: 'spline',
      },
      title: {
        text: 'Biểu đồ doanh thu theo hình thức thanh toán',
      },
      yAxis: {
        title: null,
      },

      xAxis: {
        type: 'datetime',
        labels: {
          formatter: function () {
            return Highcharts.dateFormat('%d/%m/%Y', this.value);
          },
        },
        // categories: dataAll?.map((i) => i.date),
      },
      tooltip: {
        crosshairs: true,
        shared: true,
        xDateFormat: '%d/%m/%Y',
      },
      plotOptions: {
        series: {
          label: null,
        },
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'VNPay',
          tooltip: {
            valueSuffix: ' VND',
          },
          // data: dataAll?.map((i) => i.totalVNPay),
          data: arr_VNPay,
        },
        {
          name: 'Tiền mặt',
          tooltip: {
            valueSuffix: ' VND',
          },
          // data: dataAll?.map((i) => i.totalCash),
          data: arr_Cash,
        },
      ],
    });
  };
  useEffect(() => {
    const fetchData = async () => {
      const res = await requestPOST(`api/v1/dashboard/doanhthuchitiet`, {
        fromDate: fromDateToDate.fromDate.format('YYYY-MM-DD'),
        toDate: fromDateToDate.toDate.format('YYYY-MM-DD'),
        branchId: CheckRole(currentPermissions, ['Permissions.HeThong.Manage']) ? null : currentUser?.branchId ?? null,
      });

      var _data = res?.data ?? null;
      if (_data) {
        getOptionColumn(_data);
        getOptionLine(_data);
      }
    };
    fetchData();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDateToDate]);

  useEffect(() => {
    const fetchData = async () => {
      const toDate = moment().add(1, 'days').format('YYYY-MM-DD');
      const fromDate = moment().subtract(1, 'years').format('YYYY-MM-DD');

      const res = await requestPOST_NEW(`api/v1/dashboard/dashboard`, {
        fromDate: fromDate,
        toDate: toDate,
        branchId: currentUser?.branchId ?? null,
      });

      var _data = res?.data?.data ?? null;
      if (_data) {
        let arr_ThoiGian = [];
        let arr_DoanhThu = [];

        // Sort data by time
        const sortedData = _data.sort((a, b) => {
          const [monthA, yearA] = a.thoiGian.split('/');
          const [monthB, yearB] = b.thoiGian.split('/');
          const dateA = new Date(yearA, parseInt(monthA) - 1);
          const dateB = new Date(yearB, parseInt(monthB) - 1);
          return dateA - dateB;
        });

        // Format time as MM/YYYY
        sortedData.forEach((i) => {
          const [month, year] = i.thoiGian.split('/');
          const formattedTime = `${month.padStart(2, '0')}/${year}`;
          arr_ThoiGian.push(formattedTime);
          arr_DoanhThu.push(i?.totalRevenue ?? 0);
        });

        setOption({
          ...optionChart,
          xAxis: {
            categories: arr_ThoiGian,
          },
          series: [
            {
              name: 'Doanh thu',
              tooltip: {
                valueSuffix: ' VND',
              },
              data: arr_DoanhThu,
            },
          ],
        });
      }
    };
    fetchData();
    return () => {};
  }, [currentUser?.branchId]);

  return (
    <>
      {CheckRole(currentPermissions, ['Permissions.HeThong.Manage']) ||
      CheckRole(currentPermissions, ['Permissions.DonVi.Manage']) ||
      CheckRole(currentPermissions, ['Permissions.BaoCao.Manage']) ? (
        <div className='row g-5 g-xl-10'>
          <div className='col-xl-12'>
            <div className='card card-xxl-stretch mb-xl-3'>
              {/*begin::Header*/}
              <div className='card-header'>
                {/*begin::Title*/}
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bold text-dark'>Doanh thu của các đơn vị</span>
                  <span className='text-gray-400 pt-2 fw-semibold fs-6'> </span>
                </h3>
                {/*end::Title*/}
                {/*begin::Toolbar*/}
                <div className='card-toolbar'>
                  {/*begin::Nav*/}

                  <RangePicker
                    locale={locale}
                    onChange={onChange}
                    //defaultValue={[dayjs().startOf('month'), dayjs().endOf('month')]}
                    value={[fromDateToDate?.fromDate, fromDateToDate?.toDate]}
                    format={dateFormat}
                  />
                </div>
              </div>
              <div className='card-body pt-5'>
                <div className='row'>
                  {/* <div className='col-xl-4'>
                    <div className='m-0'>
                      {dataDoanhThuChiNhanh.map((i) => (
                        <>
                          <div className='d-flex flex-stack'>
                            <div className='d-flex align-items-center me-5'>
                              <div className='me-5'>
                                <a href='#' className='text-gray-800 fw-bold text-hover-primary fs-6'>
                                  {i?.name ?? ''}
                                </a>
                                <span className='text-gray-400 fw-semibold fs-7 d-block text-start ps-0'>{i?.address ?? ''}</span>
                              </div>
                            </div>
                            <div className='d-flex align-items-center'>
                              <span className='text-gray-800 fw-bold fs-4 me-3'>
                                {`${(i?.totalRevenueCurrentMonth ?? 0).toLocaleString('vi', {
                                  style: 'currency',
                                  currency: 'VND',
                                })}`}
                              </span>
                              <div className='m-0'>
                                {((i?.totalRevenueLastMonth ?? 0) > 0
                                  ? (((i?.totalRevenueCurrentMonth ?? 0) - (i?.totalRevenueLastMonth ?? 0)) / (i?.totalRevenueLastMonth ?? 0)) * 100
                                  : 0) > 0 ? (
                                  <span
                                    className={`badge badge-light-${
                                      ((i?.totalRevenueLastMonth ?? 0) > 0
                                        ? (((i?.totalRevenueCurrentMonth ?? 0) - (i?.totalRevenueLastMonth ?? 0)) / (i?.totalRevenueLastMonth ?? 0)) *
                                          100
                                        : 0) > 0
                                        ? 'primary'
                                        : 'danger'
                                    } fs-base`}
                                  >
                                    <i
                                      className={`me-2 fa fa-arrow-${
                                        ((i?.totalRevenueLastMonth ?? 0) > 0
                                          ? (((i?.totalRevenueCurrentMonth ?? 0) - (i?.totalRevenueLastMonth ?? 0)) /
                                              (i?.totalRevenueLastMonth ?? 0)) *
                                            100
                                          : 0) > 0
                                          ? 'up'
                                          : 'down'
                                      } fs-5 text-${
                                        ((i?.totalRevenueLastMonth ?? 0) > 0
                                          ? (((i?.totalRevenueCurrentMonth ?? 0) - (i?.totalRevenueLastMonth ?? 0)) /
                                              (i?.totalRevenueLastMonth ?? 0)) *
                                            100
                                          : 0) > 0
                                          ? 'primary'
                                          : 'danger'
                                      } ms-n1`}
                                    ></i>
                                    {(i?.totalRevenueLastMonth ?? 0) > 0
                                      ? (
                                          (((i?.totalRevenueCurrentMonth ?? 0) - (i?.totalRevenueLastMonth ?? 0)) / (i?.totalRevenueLastMonth ?? 0)) *
                                          100
                                        ).toFixed(2) + '%'
                                      : ''}
                                  </span>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className='separator separator-dashed my-4' />
                        </>
                      ))}
                    </div>
                  </div> */}
                  <div className='col-xxl-6'>
                    <HighchartsReact highcharts={Highcharts} options={optionColumn} />
                  </div>
                  <div className='col-xxl-6'>
                    <HighchartsReact highcharts={Highcharts} options={optionLine} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className='row g-5 gx-xxl-8'>
        <div className='col-xxl-4'>
          <div className={`card card-xxl-stretch mb-xl-3`}>
            {/* begin::Beader */}
            <div className='card-header'>
              {/*begin::Title*/}
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold text-dark'>Thiết bị</span>
                <span className='text-gray-400 pt-2 fw-semibold fs-6'> </span>
              </h3>
            </div>
            {/* end::Header */}

            <div className='card-body d-flex flex-column'>
              <div className='mt-5'>
                <div className='d-flex flex-stack mb-5'>
                  <div className='d-flex align-items-center me-2'>
                    <div className='symbol symbol-50px me-3'>
                      <div className='symbol-label bg-light'>
                        <img src={toAbsoluteUrl('/media/svg/brand-logos/plurk.svg')} alt='' className='h-50' />
                      </div>
                    </div>
                    <div>
                      <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bold'>
                        Thiết bị đang hoạt động
                      </a>
                      <div className='fs-7 text-muted fw-semibold mt-1'>Danh sách thiết bị đang hoạt động</div>
                    </div>
                  </div>
                  <div className='badge badge-light fw-semibold py-4 px-3 text-gray-800 fw-bold fs-4'>{tongHopThietBi?.thietBiDangHoatDong ?? 0}</div>
                </div>
                <div className='d-flex flex-stack mb-5'>
                  <div className='d-flex align-items-center me-2'>
                    <div className='symbol symbol-50px me-3'>
                      <div className='symbol-label bg-light'>
                        <img src={toAbsoluteUrl('/media/svg/brand-logos/figma-1.svg')} alt='' className='h-50' />
                      </div>
                    </div>
                    <div>
                      <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bold'>
                        Thiết bị đang trục trặc
                      </a>
                      <div className='fs-7 text-muted fw-semibold mt-1'>Thiết bị đang mất kết nối tới server</div>
                    </div>
                  </div>

                  <div className='badge badge-light fw-semibold py-4 px-3 text-gray-800 fw-bold fs-4'>{tongHopThietBi?.thietBiMatKetNoi ?? 0}</div>
                </div>
                <div className='d-flex flex-stack mb-5'>
                  <div className='d-flex align-items-center me-2'>
                    <div className='symbol symbol-50px me-3'>
                      <div className='symbol-label bg-light'>
                        <img src={toAbsoluteUrl('/media/svg/brand-logos/figma-1.svg')} alt='' className='h-50' />
                      </div>
                    </div>
                    <div>
                      <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bold'>
                        Thiết bị chưa kết nối
                      </a>
                      <div className='fs-7 text-muted fw-semibold mt-1'>Thiết bị đã khai báo nhưng chưa từng kết nối tới server</div>
                    </div>
                  </div>

                  <div className='badge badge-light fw-semibold py-4 px-3 text-gray-800 fw-bold fs-4'>{tongHopThietBi?.thietBiChuaHoatDong ?? 0}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-xxl-8'>
          <div className={`card card-xxl-stretch`}>
            <div className='card-header ribbon ribbon-top ribbon-vertical px-3'>
              <div className='card-title '>
                <span className='fa fa-chart-bar me-3 '></span> Doanh thu theo tháng
              </div>
            </div>
            <div className='card-body'>
              <HighchartsReact highcharts={Highcharts} options={optionChart} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const DashboardWrapper = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  );
};

export {DashboardWrapper};
